export default __webpack_public_path__ + "static/media/team112.17481b37.JPG";